import { render } from "./modal-crea-attivita.vue?vue&type=template&id=5eec03c8&scoped=true"
import script from "./modal-crea-attivita.vue?vue&type=script&lang=js"
export * from "./modal-crea-attivita.vue?vue&type=script&lang=js"

import "./modal-crea-attivita.vue?vue&type=style&index=0&id=5eec03c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5eec03c8"]])

export default __exports__